import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";
  console.log(params.trip);

  switch (params.trip) {
    case "October-27":
      dates = "October 2 - 12, 2027";
      break;

    case "trip":
      dates = "";
      break;
  }
  return (
    <div className={styles.backgroundPicturePoland}>
      <div className={styles.titleBox}>
        <h1>Go to the land of</h1>
        <p className={styles.title}>Poland</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            A vibrant country filled with friendly people, delicious food, and a
            powerful history.{" "}
          </p>
          <p>Tour Warsaw, Krakow, Zakopane and Auschwitz-Birkenau.</p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
